import { PermissionNames } from "../types/account.types"
import { FooterMenu } from "../types/common.types"
import { RightElement, SettingsParentPage } from "./header.types"

export const NAVIGATION_ITEMS: FooterMenu[] = [
  {
    title: 'About Us',
    isALink: true,
    link: 'about-us-section'
  },
  {
    title: 'How it Works',
    isALink: true,
    link: 'how-it-work-section'
  },
  {
    title: 'Browse Our Shop',
    isALink: false,
    link: '/shop'
  },
  {
    title: 'Blog',
    isALink: false,
    link: '/pages/blog',
  },
  {
    title: 'Gift Cards',
    isALink: false,
    link: '/pages/gift-cards',
  }
  // {
  //   title: 'Donate',
  //   isALink: false,
  //   link: '/',
  // }
]

export const SETTINGS_PAGES: SettingsParentPage[] = [
  {
    icon: 'account_circle',
    name: 'Account settings',
    children: [
      {
        route: '/settings/account/profile',
        name: 'Profile',
        permissionName: PermissionNames.settingsProfile
      },
      {
        route: '/settings/account/subscriptions',
        name: 'Subscriptions',
        permissionName: PermissionNames.settingsSubscription
      },
      {
        route: '/settings/account/deliveries',
        name: 'Deliveries',
        name2: 'Pick-Ups',
        permissionName: PermissionNames.settingsDeliveries
      },
      {
        route: '/settings/account/friend-referrals',
        name: 'Friend Referrals',
        permissionName: PermissionNames.settingsFriednReferrals
      },
    ],
    permissionName: PermissionNames.settings
  },
  {
    icon: 'credit_card',
    name: 'Billing settings',
    children: [
      {
        route: '/settings/billing/payment-method',
        name: 'Payment Method',
        permissionName: PermissionNames.settingsPaymentMethod
      },
      {
        route: '/settings/billing/membership',
        name: 'Membership',
        permissionName: PermissionNames.settingsMemebership
      },
      {
        route: '/settings/billing/order-and-billing',
        name: 'Order & Billing',
        permissionName: PermissionNames.settingsOrderHistory
      },
      {
        route: '/settings/billing/invoice-history',
        name: 'Invoice History',
        permissionName: PermissionNames.settingsInvoiceHistory
      },
    ],
    permissionName: PermissionNames.settings
  },
]

export const RIGHT_ELEMENTS: RightElement[] = [
  {
    tooltip: 'Favorites',
    route: '/favorites',
    icon: 'favorite',
    permissionName: PermissionNames.shop
  },
  {
    tooltip: 'Buy Again',
    route: '/buy-again',
    icon: 'verified',
    permissionName: PermissionNames.shop
  },
  {
    id: 'toggleCardPreviewNav',
    tooltip: 'Cart',
    route: '',
    icon: 'shopping_cart',
    showBadge: true,
    permissionName: PermissionNames.order,
    showWithoutPermission: true,
    shouldShowCartPreview: true
  },
]
